// extracted by mini-css-extract-plugin
export default {"version":"VersionInfo_version__fjSHF","hover":"VersionInfo_hover__DL+Ws","inner":"VersionInfo_inner__3chdU","fixed":"VersionInfo_fixed__UTJ6P"};